import { Container } from '@mui/material';

const MaxWidthContainer = ({ children }) => (
  <Container
    maxWidth='xl'
    sx={{
      position: 'relative',
      zIndex: 'inherit',
    }}
  >
    {children}
  </Container>
);

export default MaxWidthContainer;
